import { Box, Typography, useTheme, alpha } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { KeyHint } from './KeyHint';

interface IFormaProntaPanelProps {
  titulo: string;
  descricao: string;
  documentoLabel: string;
}

// Preenche o lado do conteúdo quando a forma de pagamento selecionada não
// pede NENHUM campo extra (Dinheiro é o caso mais comum — vai direto pro
// caixa da sessão ativa, sem conta/bandeira/autorização pra preencher) —
// sem isso, a lateral direita da dialog ficava vazia enquanto a lista de
// formas ocupa só a esquerda (ver Dialogsendnfce.tsx/Dialogsendnfe.tsx).
export const FormaProntaPanel: React.FC<IFormaProntaPanelProps> = ({ titulo, descricao, documentoLabel }) => {
  const theme = useTheme();
  const corAccent = theme.torq.sidebar.iconActive;

  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 220,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
        px: 3,
        py: 4,
        border: `1px dashed ${theme.palette.mode === 'dark' ? theme.palette.divider : '#D9E2EA'}`,
        borderRadius: '14px',
        bgcolor: alpha(corAccent, 0.04),
      }}
    >
      <Box
        sx={{
          width: 48, height: 48, borderRadius: '50%',
          bgcolor: alpha(corAccent, 0.14),
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: corAccent,
          mb: 0.5,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 26 }} />
      </Box>
      <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
        {titulo}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 320, fontSize: '0.82rem' }}>
        {descricao}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 1 }}>
        <KeyHint>F12</KeyHint>
        <Typography variant="caption" color="text.secondary">
          {documentoLabel}
        </Typography>
      </Box>
    </Box>
  );
};
